import { useEffect, useState } from 'react';
import Header from '@/components/feature/Header';
import TabBar from '@/components/feature/TabBar';
import BannerCarousel from '@/components/feature/BannerCarousel';
import AnnouncementList from '@/components/feature/AnnouncementList';
import FeaturedProductCard from '@/components/feature/FeaturedProductCard';
import VoucherMall from '@/components/feature/VoucherMall';
import { getHome } from '@/api';
import type { HomeData } from '@/api';

export default function Home() {
  const [data, setData] = useState<HomeData | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    getHome()
      .then((res) => {
        if (mounted) setData(res);
      })
      .catch((err) => {
        if (mounted) setError(err instanceof Error ? err.message : '加载失败');
      });
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="mobile-container pb-20">
      <Header nickname={data?.nickname} />

      <main className="bg-background-100 min-h-screen">
        {error ? (
          <div className="flex flex-col items-center justify-center py-24">
            <i className="ri-wifi-off-line text-foreground-300 text-4xl mb-3" />
            <p className="text-foreground-400 text-sm">{error}</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-4 px-6 py-2 rounded-full bg-primary-500 text-white text-xs font-bold"
            >
              重新加载
            </button>
          </div>
        ) : !data ? (
          <div className="flex flex-col items-center justify-center py-24">
            <i className="ri-loader-4-line text-primary-400 text-3xl animate-spin mb-3" />
            <p className="text-foreground-400 text-sm">加载中...</p>
          </div>
        ) : (
          <>
            {/* Banner Carousel */}
            {data.banners && data.banners.length > 0 && <BannerCarousel banners={data.banners} />}

            {/* Announcements */}
            <AnnouncementList announcements={data.announcements} />

            {/* Featured Product */}
            {data.featuredProduct && <FeaturedProductCard product={data.featuredProduct} />}

            {/* Voucher Mall */}
            <VoucherMall products={data.voucherProducts} />
          </>
        )}

        {/* Bottom Spacing */}
        <div className="h-4" />
      </main>

      <TabBar />
    </div>
  );
}
